import React from 'react';
import './IdleWarning.css';

/**
 * The last minute before a seller is signed out for being away.
 *
 * Signing someone out without warning loses whatever they were half way
 * through typing, so this asks first — and any click, key or scroll anywhere
 * counts as an answer, not only the button.
 */
const IdleWarning = ({ secondsLeft, onStay, onLogoutNow }) => (
  <div className="idle-warning-backdrop" role="alertdialog" aria-modal="true"
       aria-labelledby="idle-warning-title">
    <div className="idle-warning">
      <h3 id="idle-warning-title">Still there?</h3>
      <p>
        You have not used the portal for a while. For your shop's safety you
        will be signed out in <strong>{secondsLeft}s</strong>.
      </p>
      <div className="idle-warning-actions">
        <button type="button" className="idle-warning-secondary"
                onClick={onLogoutNow}>
          Sign out now
        </button>
        <button type="button" className="idle-warning-primary" onClick={onStay}>
          Stay signed in
        </button>
      </div>
    </div>
  </div>
);

export default IdleWarning;
